class Accordion {
	#accordionElement;

	constructor(toggle = true, containerSelector = '.accordion', headerSelector = '.accordion-header', paneSelector = '.accordion-pane') {
		this.isToggle = toggle;
		this.accordionContainerSelector = containerSelector;
		this.accordionHeaderSelector = headerSelector;
		this.accordionPaneSelector = paneSelector;

		this.accordionElement = document.querySelector(this.accordionContainerSelector);
		if (!this.accordionElement) {
			throw new Error(`Element with selector "${containerSelector}" not found.`);
		}

		this.accordionElement.querySelectorAll(this.accordionHeaderSelector).forEach(header => {
			if (header.nextElementSibling.matches(this.accordionPaneSelector)) {

				header.setAttribute('role', 'button');
				header.setAttribute('tabindex', '0');
				header.id = `accordion-header-${Math.random().toString(36).substring(2, 9)}`;
				header.nextElementSibling.setAttribute('role', 'region');
				header.nextElementSibling.setAttribute('aria-labelledby', header.id);
				header.nextElementSibling.id = `accordion-pane-${Math.random().toString(36).substring(2, 9)}`;
				header.setAttribute('aria-expanded', header.classList.contains('expanded'));
				header.nextElementSibling.setAttribute('aria-hidden', !header.classList.contains('expanded'));
				header.nextElementSibling.style.maxHeight = header.classList.contains('expanded') ? `${header.nextElementSibling.scrollHeight}px` : '0';

				header.addEventListener('click', this.toggleItem.bind(this, header));
				header.addEventListener('keydown', this.handleKeyDown.bind(this));
				header.addEventListener('keyup', this.handleKeyUp.bind(this))
			}

		});
	}

	handleKeyDown(event) {
		if (event.key === ' ') {
			event.preventDefault();
		} else if (event.key === 'Enter') {
			event.preventDefault();
			this.toggleItem(event.currentTarget);
		}
	}

	handleKeyUp(event) {
		if (event.key === ' ') {
			event.preventDefault();
			this.toggleItem(event.currentTarget);
		}
	}

	toggleItem(item) {
		if (this.isToggle) {
			item.parentElement.querySelectorAll(this.accordionHeaderSelector).forEach(header => {
				if (header !== item && header.getAttribute('aria-expanded') === 'true') {
					this.toggleItemState(header);
				}
			});
		}
		this.toggleItemState(item);
	}

	toggleItemState(item) {
		item.classList.toggle('expanded');
		item.setAttribute('aria-expanded', item.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
		item.nextElementSibling.setAttribute('aria-hidden', item.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
		item.nextElementSibling.style.maxHeight = item.getAttribute('aria-expanded') === 'true' ? `${item.nextElementSibling.scrollHeight}px` : '0';
	}
}

export default Accordion;
